import { formValueSelector } from "redux-form";
import { createSelector } from "reselect";

export const inputsFormName = "inputs";
const inputsFormSelector = formValueSelector(inputsFormName);

export const getErgebnisValues = state =>
  inputsFormSelector(state, "ergebnisValues");

export const getAnzahlDimensionen = state =>
  inputsFormSelector(state, "anzahlDimensionen");

export const getWareneingangMenge = state =>
  inputsFormSelector(state, "anzahlWarenlieferung");
export const getWarenEinheit = state =>
  inputsFormSelector(state, "warenlieferungEinheit");
export const getWarenlieferungZeit = state =>
  inputsFormSelector(state, "warenlieferungZeiteinheit");

export const getAnzahlBestellungen = state =>
  inputsFormSelector(state, "anzahlBestellungen");
export const getBestellungenEinheit = state =>
  inputsFormSelector(state, "bestellungenEinheit");
export const getDurchschnittArtikelProBestellung = state =>
  inputsFormSelector(state, "durchschnittArtikelProBestellung");

export const getRetourenExist = state =>
  inputsFormSelector(state, "retourenExist");
export const getAnzahlRetouren = state =>
  inputsFormSelector(state, "anzahlRetouren");
export const getRetourenEinheit = state =>
  inputsFormSelector(state, "retourenEinheit");
export const getDurchschnittArtikelProRetoure = state =>
  inputsFormSelector(state, "durchschnittArtikelProRetoure");
export const getAnteilBWare = state => inputsFormSelector(state, "anteilBWare");
export const getAufzubereitendeRetourenmenge = state =>
  inputsFormSelector(state, "aufzubereitendeRetourenmenge");

export const getVersandCarrier = state =>
  inputsFormSelector(state, "versandCarrier");



// WEBPACK FOOTER //
// ./src/selectors/inputsSelectors.js